// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

export const fetchASRsByQuery = q => fetchWrapper(`/fcc/asrs${q}`)

export const fetchSiteByASR = v => fetchWrapper(`/fcc/asrs/${v}`)

export const fetchSiteByCallSign = v => fetchWrapper(`/fcc/callsigns/${v}`)

export const fetchSitesByQuery = q => fetchWrapper(`/sites${q}`)
